import { Button, Card, Modal, Row, Spin, List, Typography } from "antd";
import React, { useState } from "react";

import arrowRight from "../../assets/icons/arrow-circle-right.svg";
import arrowLeft from "../../assets/icons/arrow-circle-left.svg";

export default function TreatmentPlanTablePatientEducatoin({
  isLoadingEducationalContent,
  setCurrentPage,
  handleEduList,
  currentPage,
  edulist,
  record,
}) {
  const [showModalID, setShowModalID] = useState(null); // Track which record's modal is open
  const [educatoinalContentType, setEducationalContentType] = useState("video");

  const isTHereAnyContent = record && record.educational_content && record.educational_content.length > 0;
  const videos =
    isTHereAnyContent && record.educational_content[0].videos.reduce((videos, video) => (video.video ? [...videos, video.video] : videos), []);
  const links = isTHereAnyContent && record.educational_content[0].videos.reduce((links, video) => (video.link ? [...links, video.link] : links), []);

  // Determine if educational content exists
  const contentExists =
    edulist &&
    edulist.educational_content &&
    edulist.educational_content.length > 0 &&
    edulist.educational_content.some((item) => item.video_file && item.video_file.length > 0);

  // Get the total number of video files if educational_content exists
  const totalPages = contentExists
    ? edulist.educational_content.reduce((total, item) => total + (item.video_file ? item.video_file.length : 0), 0)
    : 0;

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  function handleLearnMoreButton() {
    if (record.educational_conent_count === 0) return;

    const firstContent = record.educational_content[0];
    const firstVideo = firstContent && firstContent.videos && firstContent.videos[0];
    // const isThereOnlyOneVideos = record.educational_conent[0].videos.length;

    if (firstVideo && firstVideo.redirect && firstVideo.link && links.length === 1 && videos.length === 0) {
      window.open(firstVideo.link, "_blank", "noopener,noreferrer");
    } else {
      // Open modal for video files or non-redirect links
      if (links.length > 1) setEducationalContentType("link");
      else setEducationalContentType("video");
      // handleEduList(record.key);
      setShowModalID(record.key);
    }
  }

  return (
    <Row align="bottom">
      <Button
        style={{
          color: record.educational_conent_count === 0 ? "#8a8a8a" : "#6B43B5",
          border: "none",
          backgroundColor: "transparent",
          textDecoration: "underline",
          cursor: record.educational_conent_count === 0 ? "default" : "pointer",
          width: "100%",
        }}
        disabled={record.educational_conent_count === 0}
        onClick={handleLearnMoreButton}
      >
        Learn More
      </Button>

      <Modal open={showModalID && showModalID === record.key} onCancel={() => setShowModalID(null)} footer={null} title="Educational Content">
        {isLoadingEducationalContent.includes(record.key) ? (
          <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Spin />
          </div>
        ) : (
          <div className="card-in-modal">
            <div className="insideCardModal">
              {record && record.educational_content && record.educational_content.length > 0 ? (
                <div>
                  {videos.length > 0 && links.length > 0 && (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 30,
                      }}
                    >
                      <div
                        style={{
                          borderRadius: 100,
                          boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
                          padding: "7px",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 10,
                        }}
                      >
                        <Button
                          className={`post-payment-predetermination-tabs ${educatoinalContentType === "video" ? "active" : ""} `}
                          onClick={() => setEducationalContentType("video")}
                        >
                          Educational Contents
                        </Button>
                        <Button
                          className={`post-payment-predetermination-tabs ${educatoinalContentType === "link" ? "active" : ""} `}
                          onClick={() => setEducationalContentType("link")}
                        >
                          Educational Links
                        </Button>
                      </div>
                    </div>
                  )}

                  <Card>
                    {educatoinalContentType === "video" ? (
                      record.educational_content[0] &&
                      record.educational_content[0].videos &&
                      record.educational_content[0].videos[currentPage] &&
                      record.educational_content[0].videos[currentPage].link &&
                      (record.educational_content[0].videos[currentPage].link.indexOf("youtube.com") !== -1 ||
                        record.educational_content[0].videos[currentPage].link.indexOf("spearedu.co") !== -1 ||
                        record.educational_content[0].videos[currentPage].link.indexOf("patient-api.speareducation.com") !== -1) ? (
                        <iframe
                          width="100%"
                          height="246px"
                          src={record.educational_content[0].videos[currentPage].link.replace("watch?v=", "embed/")}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          title="Educational Video"
                        ></iframe>
                      ) : (
                        <video width="100%" height="246px" controls>
                          <source
                            src={
                              record &&
                              record.educational_content &&
                              record.educational_content[0] &&
                              record.educational_content[0].videos &&
                              record.educational_content[0].videos[currentPage] &&
                              (record.educational_content[0].videos[currentPage].video ||
                                record.educational_content[0].videos[currentPage].link ||
                                "")
                            }
                            type="video/mp4"
                          />
                          Your browser does not support the video tag.
                        </video>
                      )
                    ) : (
                      <List
                        itemLayout="horizontal"
                        dataSource={links}
                        renderItem={(item) => (
                          <List.Item>
                            <Typography.Link href={item} target="_blank">
                              {item}
                            </Typography.Link>
                          </List.Item>
                        )}
                      />
                    )}
                  </Card>
                  <Row justify="center" style={{ marginTop: 20, display: "flex", alignItems: "center" }}>
                    <Button
                      type="text"
                      icon={<img src={arrowLeft} alt="Previous" />}
                      style={{ marginTop: 25 }}
                      disabled={currentPage === 0}
                      onClick={handlePrevious}
                    />
                    <span style={{ margin: "0 10px", lineHeight: "1.5", marginTop: 25 }}>{currentPage + 1}</span>
                    <Button
                      type="text"
                      icon={<img src={arrowRight} alt="Next" />}
                      style={{ marginTop: 25 }}
                      disabled={
                        !record ||
                        !record.educational_content ||
                        !record.educational_content[0] ||
                        !record.educational_content[0].videos ||
                        currentPage === record.educational_content[0].videos.length - 1
                      }
                      onClick={handleNext}
                    />
                  </Row>
                </div>
              ) : (
                <p>No educational content available</p>
              )}
            </div>
          </div>
        )}
      </Modal>
    </Row>
  );
}
